import { RibbonGroupBase } from '../ribbon-interfaces';
import { RibbonConstants } from '../ribbon-constants';
/**
 * Show group implementation for View tab
 * @private
 */
export class ShowGroup extends RibbonGroupBase {
    /**
     * Get the Ribbon items for Show group
     *
     * @returns {RibbonGroupModel} The ribbon group model
     */
    getGroupModel() {
        return {
            header: this.localObj.getConstant(RibbonConstants.SHOW_GROUP_HEADER),
            // enableGroupOverflow: true,
            id: this.ribbonId + '_showGroup',
            overflowHeader: this.localObj.getConstant(RibbonConstants.SHOW_GROUP_HEADER),
            collections: [
                {
                    items: [
                        {
                            type: 'CheckBox',
                            keyTip: 'R',
                            checkBoxSettings: {
                                label: this.localObj.getConstant('Ruler'),
                                checked: false,
                                change: this.rulerChangeHandler.bind(this)
                            },
                            id: this.ribbonId + RibbonConstants.RULER_CHECKBOX_ID,
                            ribbonTooltipSettings: {
                                content: this.localObj.getConstant('Show or hide the rulers')
                            }
                        },
                        {
                            type: 'CheckBox',
                            keyTip: 'B',
                            checkBoxSettings: {
                                label: this.localObj.getConstant('Show Bookmarks'),
                                checked: false,
                                change: this.bookmarkMarkersChangeHandler.bind(this)
                            },
                            id: this.ribbonId + RibbonConstants.BOOKMARK_MARKERS_CHECKBOX_ID,
                            ribbonTooltipSettings: {
                                content: this.localObj.getConstant('Show or hide bookmarks')
                            }
                        },
                        {
                            type: 'CheckBox',
                            keyTip: 'K',
                            checkBoxSettings: {
                                label: this.localObj.getConstant('Navigation Pane'),
                                checked: false,
                                change: this.navigationPaneChangeHandler.bind(this)
                            },
                            id: this.ribbonId + RibbonConstants.NAVIGATION_PANE_CHECKBOX_ID,
                            ribbonTooltipSettings: {
                                content: this.localObj.getConstant('Show or hide the navigation pane')
                            }
                        }
                    ]
                }
            ]
        };
    }
    rulerChangeHandler(args) {
        this.documentEditor.documentEditorSettings.showRuler = args.checked;
        this.documentEditor.focusIn();
    }
    bookmarkMarkersChangeHandler(args) {
        this.documentEditor.documentEditorSettings.showBookmarks = args.checked;
        this.documentEditor.focusIn();
    }
    navigationPaneChangeHandler(args) {
        this.documentEditor.documentEditorSettings.showNavigationPane = args.checked;
        this.documentEditor.focusIn();
    }
    /**
     * Update selection to reflect current state
     *
     * @returns {void}
     */
    updateSelection() {
        const ribbon = this.container.ribbon.ribbon;
        const rulerCheckBox = this.container.ribbon.ribbon.getItem(this.ribbonId + RibbonConstants.RULER_CHECKBOX_ID);
        if (rulerCheckBox) {
            rulerCheckBox.checkBoxSettings.checked =
                this.documentEditor.documentEditorSettings.showRuler;
            ribbon.updateItem(rulerCheckBox);
        }
        // Bookmark markers checkbox
        const bookmarkCheckBox = ribbon.getItem(this.ribbonId + RibbonConstants.BOOKMARK_MARKERS_CHECKBOX_ID);
        if (bookmarkCheckBox) {
            bookmarkCheckBox.checkBoxSettings.checked = this.documentEditor.documentEditorSettings.showBookmarks;
            ribbon.updateItem(bookmarkCheckBox);
        }
        // Navigation pane checkbox
        const navigationCheckBox = ribbon.getItem(this.ribbonId + RibbonConstants.NAVIGATION_PANE_CHECKBOX_ID);
        if (navigationCheckBox) {
            navigationCheckBox.checkBoxSettings.checked = this.documentEditor.documentEditorSettings.showNavigationPane;
            ribbon.updateItem(navigationCheckBox);
        }
    }
}
